import { MinutePromotion } from 'elements/layout/minute/MinuteHeaderLayout/MinutePromotion/MinutePromotion';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { CtxEdit } from 'session/ctxEdit';
import { GlobalContext } from 'session/state/context';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

// const PROMOTION_ID_WAITLIST_FEATURES = 'waitlist_minute';

export const MinutePromotions = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const {
        state: { loggedUser }
    } = useContext(GlobalContext);

    const navigate = useNavigate();

    // const [saveActon] = useMutation<SavePromotionAction, SavePromotionActionVariables>(
    //     USER_SAVE_PROMOTION_ACTION
    // );

    // const clickedWaitist = loggedUser?.promotionActions.some(
    //     (e) => e.promotionId === PROMOTION_ID_WAITLIST_FEATURES
    // );

    return (
        <S_MinutePromotions className={props.className}>
            {!loggedUser && ctxEdit.worldMarkers?.length >= 5 && (
                <S_MinutePromotion
                    icon="hand-wave"
                    title={Localization.CREATING_PROMPT1}
                    text={Localization.CREATING_PROMPT1_DESC}
                    buttonText={Localization.REGISTER_ACTION}
                    buttonAction={() => {
                        navigate('/register');
                    }}
                />
            )}
            {/* {loggedUser && !clickedWaitist && (
                <S_MinutePromotion
                    icon="crown"
                    title={Localization.CREATING_PROMPT2}
                    text={Localization.CREATING_PROMPT2_DESC}
                    buttonText={Localization.JOIN_ACTION}
                    buttonAction={() => {
                        saveActon({
                            variables: {
                                promotionId: PROMOTION_ID_WAITLIST_FEATURES,
                                action: 'JOINED'
                            }
                        });
                    }}
                />
            )} */}
        </S_MinutePromotions>
    );
};

const S_MinutePromotions = styled.div``;

const S_MinutePromotion = styled(MinutePromotion)`
    margin: 0 0 20px 0;
`;
